import { onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { dataRef } from "../../server/googleFirebase";
import { objectsDataBase, pageSelect } from "../../store/actions/actions";
import { getCurrencyValue } from "../../store/selectors/selector";
import useCurrencyCoefficient from "../currency/curencyCoefficient";

export const Cards = (props) => {
    const currency = useSelector(getCurrencyValue);
    const valuteCoefficient = useCurrencyCoefficient();
    const dispatch = useDispatch();
    const [cardsList, setCardsList] = useState([]);        

    const cardsListFilter = (
        cardsList.filter((item) => {
                return (item.target === props.name)
    }));

    const itemHeader = {
        rent: 'Аренда', 
        sale: 'Продажа', 
        new: 'Новостройки'
    }

    const handleClick = () => {
        dispatch(pageSelect(props.name))
    };

    cardsListFilter.sort((a, b) => {
        if (a.price > b.price) {
            return 1;
            }
            if (a.price < b.price) {
            return -1;
            }
            return 0;
    });

    useEffect(() => {
        onValue(dataRef, (snapshot) => {
            const data = snapshot.val()
            if (data) {
                const newData = Object.entries(data).map((item) => ({
                    id: item[0],
                    ...item[1]
                  }))    
                setCardsList(newData);      
                dispatch(objectsDataBase(newData));        
            }
        });        
    }, []);

    return (
        <>
            <div className="offers-carousel-item">
                <p className="offers-carousel-item-name">{itemHeader[props.name]}</p>
                <div className="offers-carousel-card-block">
                    {cardsListFilter.slice(0, 4).map((item) => {
                        return (
                            <Link onClick={handleClick} key={Math.random() * 10000} to={`/card/${item.number}`} className="offer-card-wrp">
                                <div className="offer-card">
                                    <img className="offer-card-img" src={item.img[0]} alt="..." />
                                    <div className="offer-card-properties">
                                        <h4 className="offer-card-name">{item.objectName}</h4>
                                        <p className="offer-card-description">{item.description}</p>
                                        <p className="offer-card-price">Price <span>{Math.round(item.price * valuteCoefficient).toLocaleString()}</span> {currency} </p>
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </>
    );
}

export default Cards;